import { render } from "./trendChart.vue?vue&type=template&id=fb0d57c0&scoped=true"
import script from "./trendChart.vue?vue&type=script&lang=js"
export * from "./trendChart.vue?vue&type=script&lang=js"

import "./trendChart.vue?vue&type=style&index=0&id=fb0d57c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb0d57c0"]])

export default __exports__